import * as Sentry from '@sentry/browser'

export const handleErrors = (key, error, options = {}) => {
  const { sendToSentry = true, logToConsole = true } = options

  if (sendToSentry) {
    // Check if it's an Axios error object
    if (error && (error.isAxiosError || error.request)) {
      const status = error.response ? error.response.status : 'N/A'
      const message = `API Request Failed for '${key}': Status ${status} on ${error.config?.url || 'unknown URL'}`
      const syntheticError = new Error(message)

      Sentry.withScope((scope) => {
        scope.setExtra('axios_details', {
          url: error.config?.url,
          method: error.config?.method,
          status: status,
          response_data: error.response?.data
        })
        Sentry.captureException(syntheticError)
      })
    } else {
      // It's a standard Error or something else we can pass directly
      Sentry.captureException(error)
    }
  }

  if (logToConsole) {
    console.error(key, error)
  }
}
